import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Card,
  Form,
  Modal,
  Table,
  Drawer,
  Input,
  Popconfirm,
  AutoComplete,
  TimePicker,
  Spin,
  Select,
} from "antd";
import {
  UsergroupAddOutlined,
  GoldFilled,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  LockOutlined,
  UnlockOutlined,
  EditOutlined,
  HourglassOutlined,
} from "@ant-design/icons";
import ListTeamApi, {
  ListChiTietBoPhanApi,
  PostBoPhanApi,
  PostTeamApi,
  PutChangeTeamApi,
  PutTeamApi,
} from "../../../api/getListTeam";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { openNotificationWithIcon } from "../../Function";
import { Link } from "react-router-dom";
import CaLamViecApi, {
  PostCaLamApi,
  PutCaLamApi,
} from "../../../api/getCaLamViec";
import { useSelector } from "react-redux";
import moment from "moment";
import ModalAutoAttend from "./AutoAttend/ModalAutoAttend";

const { Text } = Typography;
const { Search } = Input;
const validateMessages = {
  required: "${label} là bắt buộc.",
  types: {},
  number: {},
};

const ModalChangeTeam = ({
  visible,
  onCloseChangeTeam,
  dataBP,
  viewListTeam,
  detailTeam,
}) => {
  const [form] = Form.useForm();
  const [newData, setNewData] = useState([]);

  useEffect(() => {
    form.resetFields();
    setNewData(dataBP);
    if (detailTeam.length != 0) {
      form.setFieldsValue({
        tenTeam: detailTeam.tenTeam,
        tenBophan: detailTeam.tenBophan,
      });
    }
  }, [visible]);

  const onFinish = (values) => {
    var get_id_bophan = dataBP.filter(
      (item) => item.tenBophan == values.tenBophan
    );
    if (get_id_bophan.length == 0) {
      openNotificationWithIcon(
        "error",
        "Tên bộ phận không tồn tại trên hệ thống"
      );
      return;
    }

    PutChangeTeamApi({
      teamId: detailTeam.idTeam,
      bophanId: get_id_bophan[0].id,
    })
      .then((r) => {
        openNotificationWithIcon(
          "success",
          "Cập nhật thông tin Team thành công"
        );
        onCloseChangeTeam();
        viewListTeam();
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  return (
    <Modal
      title={"Chi tiết Team"}
      open={visible}
      onCancel={onCloseChangeTeam}
      footer={false}
      width={500}
      className={"site-drawer-render-in-current-wrapper"}
      bodyStyle={{ padding: "0px 12px 12px 12px" }}
    >
      <>
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          validateMessages={validateMessages}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên bộ phận"
                name="tenBophan"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Chon bộ phận"
                  onChange={(value) => {
                    form.setFieldsValue({ tenBophan: value });
                  }}
                >
                  {newData.map((item, key) => (
                    <Select.Option key={item.id} value={item.tenBophan}>
                      {item.tenBophan}
                    </Select.Option>
                  ))}
                </Select>
                {/* <Input.Group compact>
                  <AutoComplete
                    style={{ width: "100%" }}
                    placeholder="Chon bộ phận"
                    onChange={(value) => {
                      form.setFieldsValue({ tenBophan: value });
                    }}
                  >
                    {newData.map((item) => (
                      <AutoComplete.Option key={item.id} value={item.tenBophan}>
                        {item.tenBophan}
                      </AutoComplete.Option>
                    ))}
                  </AutoComplete>
                </Input.Group> */}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên team"
                name="tenTeam"
                rules={[{ required: true }]}
              >
                <Input maxLength={100} disabled />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
            <Button type="success" htmlType="submit" className={"m-2"}>
              Cập nhật
            </Button>
            <Button onClick={onCloseChangeTeam}>Thoát</Button>
          </Form.Item>
        </Form>
      </>
    </Modal>
  );
};

const ModalBoPhan = ({ visible, onCancel }) => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({ pageSize: defaultPageSize });
  const [isShowTaoTeam, setIsShowTaoTeam] = useState(false);
  const [isShowChangeTeam, setIsShowChangeTeam] = useState(false);
  const [loadingBP, setLoadingBP] = useState(false);
  const [data, setData] = useState([]);
  const [detailTeam, setDetailTeam] = useState([]);
  const [dataBP, setDataBP] = useState([]);
  const [search, setSearch] = useState("");
  // const [lsTeam, setLsTeam] = useState([]);
  // const [lsBoPhan, setLsBoPhan] = useState([]);

  // const fetchListTeam = () =>{
  //     ListTeamApi().then(res=>{
  //         console.log(res.data);
  //         setLsTeam(res.data);
  //     });
  // };

  const mapData = (data, search) => {
    let results = [];
    for (let item of data) {
      if (item.team.length === 0) {
        let obj = {};
        obj.id = results.length;
        obj.tenBophan = item.tenBophan;
        results.push(obj);
        continue;
      }
      for (let i of item.team) {
        if (search == "") {
          let obj = {};
          obj.id = results.length;
          obj.tenBophan = item.tenBophan;
          // obj.mota = item.mota;
          // obj.idBoPhan = item.id;
          obj.tenTeam = i.tenTeam;
          obj.idTeam = i.id;
          obj.isActive = i.isActive;
          obj.soLuongUser = i.detailUserteam.length;
          results.push(obj);
          continue;
        }
        if (i.tenTeam.includes(search)) {
          let obj = {};
          obj.id = results.length;
          obj.tenBophan = item.tenBophan;
          // obj.mota = item.mota;
          // obj.idBoPhan = item.id;
          obj.tenTeam = i.tenTeam;
          obj.idTeam = i.id;
          obj.isActive = i.isActive;
          obj.soLuongUser = i.detailUserteam.length;
          results.push(obj);
        }
      }
    }
    return results;
  };

  const fetchListBoPhan = (params = {}) => {
    setLoadingBP(true);
    ListChiTietBoPhanApi({ ...params }).then((res) => {
      // setLsBoPhan(res.data);
      setDataBP(res.data);
      const newData = mapData(res.data, params.search);
      // setData([]);
      setData(newData);
      setLoadingBP(false);
    });
  };

  // useEffect(() => {
  // fetchListTeam();
  // fetchListBoPhan();
  // }, []);

  const onLock_Unlock = (record) => {
    PutTeamApi({
      teamId: record.idTeam,
      block: "true",
      isActive: !record.isActive,
    })
      .then((r) => {
        // console.log(r);
        fetchListBoPhan({
          page: pager.current,
          page_size: pager.pageSize,
          search,
        });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });

    // PutUserApi({
    //     userId: record.id,
    //     isActive: !record.isActive
    // })
    // .then(r => {
    //     console.log(r);
    //     fetchListBoPhan();
    // })
    // .catch(err=>{
    //     if (err.data.error) {
    //         openNotificationWithIcon('error', err.data.error)
    //     };
    // });
  };

  const getButtonChangeStatus = (record) => {
    return (
      <>
        <Row>
          <span
            title={"Chỉnh sửa bộ phận của team"}
            className={"col-6"}
            style={{ color: "red", cursor: "pointer" }}
          >
            <EditOutlined
              style={{ color: "#008000" }}
              onClick={() => showChangeTeam(record)}
            />
          </span>
          {record.soLuongUser === 0 && record.isActive === true && (
            <Col span={8}>
              <span
                title={"Khóa team"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận khóa team"
                  onConfirm={() => onLock_Unlock(record)}
                  okText="Khóa"
                >
                  <LockOutlined style={{ color: "#ff4d4f" }} />
                </Popconfirm>
              </span>
              {/* <span
                  title={"Mở khóa team"}
                  className={"col-6"}
                  style={{ color: "red", cursor: "pointer" }}
                >
                  <Popconfirm
                    title="Xác nhận mở khóa team"
                    onConfirm={() => onLock_Unlock(record)}
                    okText="Mở khóa"
                  >
                    <UnlockOutlined style={{ color: "#008000" }} />
                  </Popconfirm>
                </span> */}
            </Col>
          )}
        </Row>
      </>
    );
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: 100,
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Bộ phận",
      dataIndex: "tenBophan",
      key: "tenBophan",
      filterKey: "tenBophan",
      type: "text",
      align: "center",
      canSearch: true,
    },
    {
      title: "Team",
      dataIndex: "tenTeam",
      key: "tenTeam",
      filterKey: "tenTeam",
      type: "text",
      align: "center",
      canSearch: true,
    },
    {
      title: "Số lượng thành viên",
      dataIndex: "soLuongUser",
      key: "soLuongUser",
      filterKey: "soLuongUser",
      type: "text",
      align: "center",
      width: 200,
      canSearch: true,
    },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "isActive",
    //   key: "isActive",
    //   filterKey: "isActive",
    //   type: "text",
    //   align: "center",
    //   canSearch: true,
    //   render: (value, record) =>
    //     value === true ? (
    //       <CheckCircleOutlined
    //         style={{ color: "#008000" }}
    //         title="Đang hoạt động"
    //       />
    //     ) : (
    //       <CloseCircleOutlined
    //         style={{ color: "#ff4d4f" }}
    //         title="Không hoạt động"
    //       />
    //     ),
    // },
    {
      title: "Thao tác",
      dataIndex: "",
      key: "",
      filterKey: "",
      type: "text",
      align: "center",
      width: 100,
      canSearch: true,
      render: (text, record) => getButtonChangeStatus(record),
    },
  ];

  const showTaoTeam = () => {
    setIsShowTaoTeam(true);
  };

  const onCloseTaoTeam = () => {
    setIsShowTaoTeam(false);
  };

  const showChangeTeam = (record) => {
    setDetailTeam(record);
    setIsShowChangeTeam(true);
  };

  const onCloseChangeTeam = () => {
    setIsShowChangeTeam(false);
  };

  const viewListTeam = () => {
    fetchListBoPhan({
      page: pager.current,
      page_size: pager.pageSize,
      search,
    });
  };

  // const mockVal = (str, repeat = 1) => ({
  //   value: str.repeat(repeat),
  // });

  const CardTaoTeam = () => {
    const [form] = Form.useForm();
    const [newData, setNewData] = useState([]);

    useEffect(() => {
      form.resetFields();
      setNewData(dataBP);
    }, []);

    const postTeam = (dataBP, values, idBP = null) => {
      PostTeamApi({
        idBophan:
          idBP == null
            ? dataBP.filter((item) => item.tenBophan == values.tenBophan)[0].id
            : idBP,
        tenTeam: values.tenTeam,
        mota: "",
      })
        .then((res) => {
          if (res.data.error) {
            openNotificationWithIcon("error", res.data.error);
          } else {
            viewListTeam();
            onCloseTaoTeam();
            form.resetFields();
          }
        })
        .catch((err) => {
          console.log(err.data);

          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
          }
        });
    };

    const onFinish = (values) => {
      if (dataBP.map((item) => item.tenBophan).includes(values.tenBophan)) {
        postTeam(dataBP, values);
      } else {
        PostBoPhanApi({
          tenBophan: values.tenBophan,
          mota: "",
        })
          .then((res) => {
            if (res.data.error) {
              openNotificationWithIcon("error", res.data.error);
            } else {
              postTeam(dataBP, values, res.data.result.idBophan);
            }
          })
          .catch((err) => {
            console.log(err);

            if (err?.data?.error) {
              openNotificationWithIcon("error", err.data.error);
            }
          });
      }
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    return (
      <>
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          validateMessages={validateMessages}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên bộ phận"
                name="tenBophan"
                rules={[{ required: true }]}
              >
                <Input.Group compact>
                  <AutoComplete
                    style={{ width: "100%" }}
                    placeholder="Nhập mới hoặc chon bộ phận để tạo team"
                    onChange={(value) => {
                      form.setFieldsValue({ tenBophan: value });
                    }}
                  >
                    {newData.map((item) => (
                      <AutoComplete.Option key={item.id} value={item.tenBophan}>
                        {item.tenBophan}
                      </AutoComplete.Option>
                    ))}
                  </AutoComplete>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên team"
                name="tenTeam"
                rules={[{ required: true }]}
              >
                <Input maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
            <Button type="success" htmlType="submit" className={"m-2"}>
              Tạo
            </Button>
            <Button onClick={onCloseTaoTeam}>Thoát</Button>
          </Form.Item>
        </Form>
      </>
    );
  };

  useEffect(() => {
    const id = setInterval(() => {
      fetchListBoPhan({ page: 1, page_size: pager.pageSize, search });
      // setPager({pageSize: defaultPageSize,current: 1});
      clearInterval(id);
    }, 500);
    return () => clearInterval(id);
  }, [search]);

  const onSearch = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  return (
    <Modal
      title={"Quản lý danh sách Team"}
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={1100}
      className={"site-drawer-render-in-current-wrapper"}
      bodyStyle={{ padding: "0px 12px 12px 12px" }}
    >
      <div style={{ display: "flex" }}>
        <Col span={12}>
          <Button
            ghost
            type="success"
            className={"m-2"}
            onClick={showTaoTeam}
            icon={<PlusCircleOutlined />}
          >
            Thêm mới
          </Button>
        </Col>
        <Col span={12}>
          <Row
            gutter={[8, 8]}
            className={"m-2 btn-tk"}
            style={{ flexDirection: "row-reverse" }}
          >
            <Col>
              <Search
                placeholder="Nhập từ khóa tìm kiếm"
                size="normal"
                onChange={onSearch}
                loading={false}
              />
            </Col>
          </Row>
        </Col>
      </div>
      <Table
        dataSource={data}
        columns={columns}
        loading={loadingBP}
        bordered={true}
        sticky={true}
        // scroll={{x:700,y:500}}
        scroll={data.length > 0 && { x: 700, y: 400 }}
        className={"custom-table-hover style-6"}
        size={"small"}
        rowKey="id"
        pagination={false}
      />
      <Drawer
        title="Tạo Team"
        placement="right"
        // width={400}
        size={"default"}
        onClose={onCloseTaoTeam}
        visible={isShowTaoTeam}
        keyboard
        className="styleDrawer"
        // bodyStyle={{padding: "5px 6px"}}
        closeIcon={<CloseCircleOutlined title="Thoát (ESC)" />}
        style={{ position: "absolute" }}
        getContainer={false}
      >
        <CardTaoTeam />
      </Drawer>
      <ModalChangeTeam
        visible={isShowChangeTeam}
        onCloseChangeTeam={onCloseChangeTeam}
        dataBP={dataBP}
        viewListTeam={viewListTeam}
        detailTeam={detailTeam}
      />
    </Modal>
  );
};

const ModalCaLam = ({ visible, onCancel }) => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({ pageSize: defaultPageSize });
  const [isShowTaoCa, setIsShowTaoCa] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchListCaLam = () => {
    ListTeamApi()
      .then((res) => {
        CaLamViecApi({
          idTeam: JSON.stringify(res.data.map((item) => item.id)),
        }).then((res2) => {
          setData(res2.data);
        });
      })
      .catch((err) => {
        setData([]);
      });
  };

  useEffect(() => {
    fetchListCaLam();
  }, []);

  const onLock_Unlock = (record) => {
    PutCaLamApi({
      idCa: record.id,
      isActive: !record.isActive,
    })
      .then((res) => {
        if (res.data.error) {
          openNotificationWithIcon("error", res.data.error);
        } else {
          fetchListCaLam();
          onCloseTaoCa();
        }
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const getButtonChangeStatus = (record) => {
    return (
      <>
        <Row>
          <Col span={8}>
            {record.isActive === true ? (
              <span
                title={"Khóa ca"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận khóa ca"
                  onConfirm={() => onLock_Unlock(record)}
                  okText="Khóa"
                >
                  <LockOutlined style={{ color: "#ff4d4f" }} />
                </Popconfirm>
              </span>
            ) : (
              <span
                title={"Mở khóa ca"}
                className={"col-6"}
                style={{ color: "red", cursor: "pointer" }}
              >
                <Popconfirm
                  title="Xác nhận mở khóa ca"
                  onConfirm={() => onLock_Unlock(record)}
                  okText="Mở khóa"
                >
                  <UnlockOutlined style={{ color: "#008000" }} />
                </Popconfirm>
              </span>
            )}
          </Col>
        </Row>
      </>
    );
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Tên ca",
      dataIndex: "tenCa",
      key: "tenCa",
      filterKey: "tenCa",
      type: "text",
      align: "center",
      canSearch: true,
    },
    {
      title: "Giờ vào",
      dataIndex: "gioVao",
      key: "gioVao",
      className: "highlight",
      filterKey: "gioVao",
      type: "text",
      align: "center",
      canSearch: true,
      render: (text, record) => text && text.toString().substr(0, 5),
    },
    {
      title: "Giờ ra",
      dataIndex: "gioRa",
      key: "gioRa",
      filterKey: "gioRa",
      className: "highlight",
      type: "text",
      align: "center",
      canSearch: true,
      render: (text, record) => text && text.toString().substr(0, 5),
    },
    {
      title: "Trạng thái",
      dataIndex: "isActive",
      key: "isActive",
      filterKey: "isActive",
      type: "text",
      align: "center",
      canSearch: true,
      render: (value, record) =>
        value === true ? (
          <CheckCircleOutlined
            style={{ color: "#008000" }}
            title="Đang hoạt động"
          />
        ) : (
          <CloseCircleOutlined
            style={{ color: "#ff4d4f" }}
            title="Không hoạt động"
          />
        ),
    },
    {
      title: "Thao tác",
      dataIndex: "active",
      key: "active",
      filterKey: "active",
      type: "text",
      align: "center",
      canSearch: true,
      render: (text, record) => getButtonChangeStatus(record),
    },
  ];

  const showTaoCa = () => {
    setIsShowTaoCa(true);
  };

  const onCloseTaoCa = () => {
    setIsShowTaoCa(false);
  };

  const CardTaoCa = () => {
    const [form] = Form.useForm();
    const [timeStart, setTimeStart] = useState(null);
    const [timeEnd, setTimeEnd] = useState(null);

    useEffect(() => {
      form.resetFields();
    }, []);

    const onFinish = (values) => {
      if (data.map((item) => item.tenCa).includes(values.tenCa)) {
        openNotificationWithIcon(
          "error",
          "Trùng tên ca trong hệ thống. Bạn vui lòng tạo lại."
        );
        return;
      }

      PostCaLamApi({
        tenCa: values.tenCa,
        gioVao: moment(timeStart._d).format("HH:mm"),
        gioRa: moment(timeEnd._d).format("HH:mm"),
        idTeam: "",
      })
        .then((res) => {
          if (res.data.error) {
            openNotificationWithIcon("error", res.data.error);
          } else {
            fetchListCaLam();
            onCloseTaoCa();
            form.resetFields();
          }
        })
        .catch((err) => {
          if (err.data.error) {
            openNotificationWithIcon("error", err.data.error);
          }
        });
    };

    const onFinishFailed = (errorInfo) => {
      console.log("Failed:", errorInfo);
    };

    const onSelectTimeStart = (value) => {
      form.setFieldsValue({ gioVao: value });
      setTimeStart(value);
    };

    const onSelectTimeEnd = (value) => {
      form.setFieldsValue({ gioRa: value });
      setTimeEnd(value);
    };

    const getDisableHourOut = () => {
      const timeIn = timeStart ? timeStart._d.getHours() : 0;
      let arrCheck = [...Array(24).keys()];
      return arrCheck.filter((item) => item < timeIn);
    };
    const getDisableHourIn = () => {
      const timeIn = timeEnd ? timeEnd._d.getHours() : 24;
      let arrCheck = [...Array(24).keys()];
      return arrCheck.filter((item) => item > timeIn);
    };

    return (
      <>
        <Form
          form={form}
          name="basic"
          layout={"vertical"}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          validateMessages={validateMessages}
        >
          <Row>
            <Col span={24}>
              <Form.Item
                label="Tên ca"
                name="tenCa"
                rules={[{ required: true }]}
              >
                <Input maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                label="Giờ vào"
                name="gioVao"
                rules={[{ required: true }]}
              >
                <TimePicker
                  format="HH:mm"
                  placeholder={"Giờ vào"}
                  onSelect={(value) => onSelectTimeStart(value)}
                  value={timeStart}
                  style={{ width: "100%" }}
                  minuteStep={15}
                  allowClear={false}
                  disabledHours={getDisableHourIn}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Giờ ra"
                name="gioRa"
                rules={[{ required: true }]}
              >
                <TimePicker
                  format="HH:mm"
                  placeholder={"Giờ ra"}
                  onSelect={(value) => onSelectTimeEnd(value)}
                  value={timeEnd}
                  style={{ width: "100%" }}
                  minuteStep={15}
                  disabledHours={getDisableHourOut}
                  allowClear={false}
                />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
            <Button type="success" htmlType="submit" className={"m-2"}>
              Tạo
            </Button>
            <Button onClick={onCloseTaoCa}>Thoát</Button>
          </Form.Item>
        </Form>
      </>
    );
  };

  return (
    <Modal
      title={"Quản lý danh sách ca làm việc"}
      visible={visible}
      onCancel={onCancel}
      footer={false}
      width={800}
      className={"site-drawer-render-in-current-wrapper"}
      bodyStyle={{ padding: "0px 12px 12px 12px" }}
    >
      <Button
        ghost
        type="success"
        className={"m-2"}
        onClick={showTaoCa}
        icon={<PlusCircleOutlined />}
      >
        Thêm mới
      </Button>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        bordered={true}
        sticky={true}
        size={"small"}
        rowKey="id"
        scroll={data.length > 0 && { x: 700, y: 400 }}
        className={"custom-table-hover style-6"}
        pagination={false}
      />
      <Drawer
        title="Tạo ca"
        placement="right"
        // width={400}
        size={"default"}
        onClose={onCloseTaoCa}
        visible={isShowTaoCa}
        keyboard
        // bodyStyle={{padding: "5px 6px"}}
        closeIcon={<CloseCircleOutlined title="Thoát (ESC)" />}
        style={{ position: "absolute" }}
        getContainer={false}
      >
        <CardTaoCa />
      </Drawer>
    </Modal>
  );
};

export const CauHinhHeThong = () => {
  const [isShowBoPhan, setIsShowBoPhan] = useState(false);
  const [isShowCaLam, setIsShowCaLam] = useState(false);
  const [isShowAutoAttend, setIsShowAutoAttend] = useState(false);

  const onShowBoPhan = () => {
    setIsShowBoPhan(true);
  };

  const onShowCaLam = () => {
    setIsShowCaLam(true);
  };

  const onShowAutoAttend = () => {
    setIsShowAutoAttend(true);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Cấu hình hệ thống</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">Cấu hình</Link>
                </li>
                <li className="breadcrumb-item active">Cấu hình hệ thống</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Row
          style={{ justifyContent: "center", textAlign: "center" }}
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
        >
          <Col span={6}>
            <Card>
              <Link to={"/cau-hinh/danh-sach-nguoi-dung"}>
                <span style={{ fontSize: 40 }}>
                  <UsergroupAddOutlined className="styleIcon_1" />
                </span>
                <h1>Người dùng</h1>
                <p>Quản lý danh sách người dùng</p>
              </Link>
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <a className="text-link" onClick={onShowBoPhan}>
                <span style={{ fontSize: 40 }}>
                  <GoldFilled className="styleIcon_1" />
                </span>
                <h1>Team</h1>
                <p>Quản lý danh sách Team</p>
              </a>
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <a className="text-link" onClick={onShowCaLam}>
                <span style={{ fontSize: 40 }}>
                  <GoldFilled className="styleIcon_1" />
                </span>
                <h1>Ca làm</h1>
                <p>Quản lý ca làm việc</p>
              </a>
            </Card>
          </Col>
        </Row>
        <Row
          style={{
            justifyContent: "center",
            textAlign: "center",
            marginTop: 8,
          }}
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
        >
          <Col span={6}>
            <Card>
              <a className="text-link" onClick={onShowAutoAttend}>
                <span style={{ fontSize: 40 }}>
                  <HourglassOutlined className="styleIcon_1" />
                </span>
                <h1>Cài đặt chấm công</h1>
                <p>Chấm công sáng thứ 7</p>
              </a>
            </Card>
          </Col>
        </Row>
      </div>
      {isShowBoPhan && (
        <ModalBoPhan
          visible={isShowBoPhan}
          onCancel={() => setIsShowBoPhan(false)}
        />
      )}
      {isShowCaLam && (
        <ModalCaLam
          visible={isShowCaLam}
          onCancel={() => setIsShowCaLam(false)}
        />
      )}
      {isShowAutoAttend && (
        <ModalAutoAttend
          isShowAutoAttend={isShowAutoAttend}
          onCancel={() => setIsShowAutoAttend(false)}
        />
      )}
    </>
  );
};
